var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "main",
    {
      directives: [
        {
          name: "loading",
          rawName: "v-loading.fullscreen.lock",
          value: _vm.loading,
          expression: "loading",
          modifiers: { fullscreen: true, lock: true },
        },
      ],
    },
    [
      _c(
        "div",
        { staticClass: "top-banner" },
        [_c("InstitutionCard", { attrs: { "card-data": _vm.schoolInfo } })],
        1
      ),
      _c("div", { staticClass: "list-container" }, [
        _c("div", { staticClass: "title-box" }, [
          _c("h2", [_vm._v("直播列表")]),
          _c("span", [_vm._v("共" + _vm._s(_vm.liveList.length) + "场直播")]),
        ]),
        _c("div", { staticClass: "filter-box" }, [
          _c("div", { staticClass: "filter-types" }, [
            _c(
              "div",
              {
                staticClass: "filter-type",
                attrs: { "data-actived": _vm.filterType === 0 },
                on: {
                  click: function ($event) {
                    _vm.filterType = 0
                  },
                },
              },
              [
                _vm.filterType === 0
                  ? _c("el-image", {
                      staticClass: "filter-icon",
                      attrs: { src: _vm.LiveTime },
                    })
                  : _vm._e(),
                _c("span", [_vm._v("直播时间")]),
              ],
              1
            ),
            _c(
              "div",
              {
                staticClass: "filter-type",
                attrs: { "data-actived": _vm.filterType === 1 },
                on: {
                  click: function ($event) {
                    _vm.filterType = 1
                  },
                },
              },
              [
                _vm.filterType === 1
                  ? _c("el-image", {
                      staticClass: "filter-icon",
                      attrs: { src: _vm.LiveMic },
                    })
                  : _vm._e(),
                _c("span", [_vm._v("直播状态")]),
              ],
              1
            ),
          ]),
          _vm.filterType === 0
            ? _c(
                "div",
                { staticClass: "filter-content" },
                _vm._l(_vm.yearList, function (item) {
                  return _c(
                    "div",
                    {
                      key: item,
                      staticClass: "filter-item",
                      attrs: { "data-actived": _vm.searchForm.year === item },
                      on: {
                        click: function ($event) {
                          _vm.searchForm.year = item
                        },
                      },
                    },
                    [_vm._v(_vm._s(item))]
                  )
                }),
                0
              )
            : _vm._e(),
          _vm.filterType === 1
            ? _c(
                "div",
                { staticClass: "filter-content" },
                _vm._l(_vm.statusList, function (item) {
                  return _c(
                    "div",
                    {
                      key: item.id,
                      staticClass: "filter-item",
                      attrs: {
                        "data-actived": _vm.searchForm.status === item.id,
                      },
                      on: {
                        click: function ($event) {
                          _vm.searchForm.status = item.id
                        },
                      },
                    },
                    [_vm._v(_vm._s(item.name))]
                  )
                }),
                0
              )
            : _vm._e(),
        ]),
        _c(
          "div",
          { staticClass: "list-box" },
          _vm._l(_vm.liveList, function (item) {
            return _c("ListCard", {
              key: item.id,
              attrs: { "card-data": item },
            })
          }),
          1
        ),
      ]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }